<template>
  <nav class="" style="margin: 0px -25px -100px -25px; height: 60px;">
    <b-field v-if="lang ==1" style="background-color: #F7F7F7;">  
      <b-field style="padding-left: 25px; padding-right: 25px;">
        <b-field style="height: 100px; padding-top: 20px;"> ອອກແບບ ແລະ <br>ພັດທະນາລະບົບໂດຍ:</b-field> <b-field style="height: 80px;"><img :src="logo" alt="" /></b-field> 
        <b-field style="padding-top: 20px;">ວິສາຫະກິດຫຸ່ນສ່ວນສາມັນ Agrilao Innovation <br>ຜູ້ສະໜອງວັດຖຸດິບໃຫ້ຮ້ານອາຫານ ໂຮງແຮມ ບໍລິສັດ ແລະ ໂຄງການ<br>ເບີໂທ: 020 55333483</b-field>  
      </b-field>
      
    </b-field> 
    <b-field v-else style="background-color: #F7F7F7;">
      <b-field style="padding-left: 25px; padding-right: 25px;">
        <b-field style="height: 100px; padding-top: 20px;"> Designed and <br>developed by:</b-field> <b-field style="height: 80px;"><img :src="logo" alt="" /></b-field> 
        <b-field style="padding-top: 20px;">Agrilao Innovation Ordinary Partnership <br>the supplier of raw materials for restaurants, hotels, companies and projects<br>Tel: 020 55333483</b-field>  
      </b-field>
      
    </b-field> 
  </nav>
</template>

<script>
export default {
  name: "footer",
  data() {
    return {
      isMenuActive: false, // Toggles the main menu visibility (hamburger menu)
      activeDropdown: null, // Tracks the currently active dropdown menu
      switchLang: 1, // Language switch: 1 for Lao, 2 for English
    };
  },
  computed: {
    logo() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/logo/logo.png'
        : 'http://localhost/lababiz/api/uploads/logo/logo.png';
    },
    lang() {
     
     return this.$store.get('switchLang') || 1;
   },
  }
};
</script>

<style scoped>
.has-dropdown {
  margin-top: 6px;
  margin-left: 12px;
  margin-right: 12px;
}

.navbar-item {
  white-space: nowrap;
  transition: color 0.3s ease;
}

/* Default styles for large screens */
.navbar-item.custom-link {
  color: white; /* Default text color */
  background-color: #039be5;
}

/* Hover effect */
.navbar-item.custom-link:hover {
  /* background-color: #007bff; Background color when hovering */
  color: white; /* Color when hovering */
}

/* Active link state */
.navbar-item.custom-link.is-active {
  /* background-color: #007bff; Background color when the link is active */
  color: white; /* Color when the link is active */
}

.navbar-end {
  padding-right: 60px;
}

.navbar-burger span {
  background-color: white; /* Customize the hamburger menu color */
}

.navbar-link {
  cursor: pointer; /* Pointer cursor for clickable menu links */
}

.navbar-dropdown {
  animation: fadeIn 0.3s; /* Optional fade-in animation for submenu */
}

/* Media query for small screens (hamburger menu active state) */
@media screen and (max-width: 768px) {
  /* Change text color to blue when menu is active on small screens */
  .navbar-menu.is-active .navbar-item.custom-link {
    color: white; /* Change text color to blue for menu items on small screens */
    background-color: #039be5;
  }

  /* On hover, change text color to dark blue */
  .navbar-menu.is-active .navbar-item.custom-link:hover {
    color: white; /* Change text color to blue for menu items on small screens */
    background-color: #039be5;
  }

  .navbar-menu.is-active .navbar-item.custom-link.is-active {
    color: white; /* Change text color to blue for menu items on small screens */
    background-color: #039be5;
  }

  /* Ensure the menu background color is still white on small screens */
  .navbar-menu.is-active {
    background-color: white;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
